import dateFns from 'date-fns'
import { Echelon } from '../../../../common/models/echelon.js'

import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE } from "../../../../interface.js"

/* @ngInject */
export class AddEnginController {
  /* @ngInject */
  constructor (ApiConst, ApiSimu, ApiExo, $scope, $q) {
    this.ApiConst = ApiConst
    this.ApiSimu = ApiSimu
    this.ApiExo = ApiExo
    this.$scope = $scope

    this.watcher = this.$scope.$watch('codemouvement', this.onChangeMouvement)
    this.onChangeMouvement = this.onChangeMouvement.bind(this)

    this.dateFormatFR = 'DD/MM/YYYY'
  }

  $onInit () {

    console.log('AddEnginController : init')

    // Test du 'require'
    console.log('AddEnginController --> require ^^simulator', this.parentSimulator)
    console.log('AddEnginController --> require ^^mouvement', this.parentMouvement)
    //console.log('AddEnginController --> require ^^edit-echelon', this.parentEditEchelon) // add-echelon n'est pas toujours un child de edit-echelon (m...)



    if (!this.doAddEchelon) return console.error(`'add-engin' doit avoir un attribut do-add-echelon"`)
    if (!this.doRefreshEchelon) return console.error(`'add-engin' doit avoir un attribut do-refresh-echelon"`)

    // this.echelon est l'échelon courant du mouvement; bindé par "echelon"

    // this.mouvement est le mouvement courant; bindé par "mouvement" ou edit-echelon

    // this.doSave ajoute l'engin à l'échelon courant (est-il nécessaire de le binder ?)
    // this.doAddEchelon créer/ajoute un nouvel échelon pour le mouvement; bindé par do-add-echelon / MouvementController::addEchelon

    // this.dataEngin représente les valeurs affichées / sélectées dans le formulaire


  // raz du formulaire ??  
  this.reset()

  console.log('AddEnginController::onInit, codeMvt, echelon', this.codemouvement, this.echelon)
  
    this.resetViewVars() //
  }


  /*
  *  changement de mouvement
  */
  onChangeMouvement (newcode, oldcode) {
    
    if(newcode === oldcode)
      return

    console.log('AddEnginController::$onChangeMouvement ', newcode, oldcode)
    this.resetViewVars()
  }

/*
* Réinit de l'affichage du bloc parametres / step3 et du bloc phases-options / step4
*/
  resetViewVars() {

      this.dataEngin.engin = undefined
      this.selectedEngin = {}

      this.enginDescription = undefined
      this.parametresList = []
      this.formattedParams = []
      this.titleForParametres = ""

      // Reinitialisation des phases
      this.phases = undefined
      this.options = undefined
      this.dataPhases = {}

      this.descriptionGodets = []

  }

  /*
  * lecture BD de ttes les familles; (pour peuplement du sélecteur dataEngin.famille avec les options dans famillesEnginsList)
  */
  fetchFamillesEngins() {
    return this.ApiConst.getAllFamillesEngins()
    .then(famillesEngins => {
      // je recupère les familles d'engins et les affiche dans le select
      this.famillesEnginsList = famillesEngins
      //console.log('AddEnginController::fetchFamillesEngins', famillesEngins)
    })
  }

/*
* path vers une image d'engin (racine == <project>/src/client/assets/img)
*/
  getImgFamille(f) {
    //return 'images/svg/' +  this.famille.code.toLowerCase() + '_grey.svg'  
    return 'images/engins/' + f.code.toLowerCase() + '_grey.svg'  
  }



/* on-Select famille
* lister les engins de la famille courante --> this.enginsList
*/
  fetchEngins () {
    var currentFamilleID = this.dataEngin.famille
    return this.ApiConst.getFamilleenginById(currentFamilleID)
    .then(famille => {
      this.famille = famille
      this.imageFamille = this.getImgFamille(famille)
      var engins = this.ApiConst.getAllEnginsByFamilleID(currentFamilleID);
      this.enginsList = engins;
      console.log('fetchEngins :', this.enginsList)

    // Reinitialisation des phases et de la colonne parametres
    this.resetViewVars()


    })
  }




/**  on select engin, lire et formatter les params de l'engin
*  afficher les phases et options pour cette famille
* Attention reprise code YL : this.dataEngin.famille == id de la famille sélectée  / this.dataEngin.engin == id de l'engin sélecté !!
*/
  fetchParametres () {
    var famille_id = this.dataEngin.famille
    var engin_id = this.dataEngin.engin
    var mouvement

    this.selectedEngin = this.getSelectedEngin(this.dataEngin.engin)
    
    return this.ApiConst.getParametresForEngin(this.dataEngin.famille, this.dataEngin.engin)
    .then(enginDescr => {
      this.enginDescription = enginDescr
      this.parametresList = enginDescr.ParamsEngin
      this.formatParamsForEngin(enginDescr.ParamsEngin)
      this.titleForParametres = this.famille.nom + ' ' + enginDescr.Nom
      console.log('description engin', this.enginDescription)

      return this.ApiConst.getPhasesForFamilleengin(this.dataEngin.famille)
    })
    .then(({phases, options}) => {
      
      var godets = this.ApiConst.getAllGodetsImmediate() // lecture des godets directe dans la table JSON (pas de Promise)
      this.recombinedPhasesOptions = this.recombinePhasesOptions(phases, options, godets, this.selectedEngin, this.famille)
      mouvement = this.parentMouvement.currentMouvement
      return this.ApiSimu.getReusableEngins(this.selectedEngin, mouvement)
    })
    // "reusables", est la liste des périodes d'usages d'engins
    // n.b. : dans les engins déclarés reusables on a aussi ceux utilisés dans ce même mouvement
    .then(reusables => {      
      
      if(!reusables || reusables.length == 0)
        return []
      var notReusablesEngins = []
  
      // tester les intersections des périodes % mouvement actuel (ce qui inclut le mouvement lui même)
      reusables.forEach(r => {
        if((mouvement.simuMouvement.debut == r.simu_mouvements.debut && mouvement.simuMouvement.fin == r.simu_mouvements.fin)
          ||
          (!(mouvement.simuMouvement.fin <= r.simu_mouvements.debut || mouvement.simuMouvement.debut >= r.simu_mouvements.fin))) {
          // si recouvrement, l'engin n'est pas réustilisable, quelque soit la période
            notReusablesEngins.push(r.simu_engins.id)
          }

      })
      // supprimer toutes les périodes pour lesquelles ont a sollicité ces engins
      notReusablesEngins.forEach(notReusableEnginId => {
        reusables = reusables.filter(r => r.simu_engins.id != notReusableEnginId)
      })
      
      /*var alreadyReused = reusables.filter(r => r.simu_mouvements.id == mouvement.simuMouvement.id)
      alreadyReused.forEach(ar => {
        var reusedsimu_engins_id = ar.simu_engins.id
        // on ne peut pas à nouveau propôser ces engins
        reusables = reusables.filter(r => r.simu_engins.id != reusedsimu_engins_id)
      })*/
      console.log('AddEnginController::recombinedPhasesOptions finaly resuables', reusables)
      this.insertReusables(reusables)
      console.log('AddEnginController::recombinedPhasesOptions ', this.recombinedPhasesOptions)
      return reusables
    })
  }

/*
* Mise en forme des propositions de sélection et copie dans chaque phase
*/
  insertReusables(reusables) {

    var reusableEngins = []
    var i=0

    // ramasser et mettre en forme les infos utiles du resultat de la requete
    reusables.forEach(r => {
      var reusableEngin = {}
      reusableEngin.simu_engins_id = r.simu_engins.id
      reusableEngin.simu_engins_reference = r.simu_engins.reference
      reusableEngin.debut = r.simu_mouvements.debut
      reusableEngin.fin = r.simu_mouvements.fin
      reusableEngin.code_mouvement = r.exo_mouvements.code
      reusableEngin.nom = r.const_engins.nom
      reusableEngin.code = r.const_engins.code
      //reusableEngin.selected = false
      

      reusableEngin.debut = dateFns.format(reusableEngin.debut, this.dateFormatFR)
      reusableEngin.fin = dateFns.format(reusableEngin.fin, this.dateFormatFR)

      reusableEngins.push(reusableEngin)

    })

    console.log('AddEnginController::insertReusables ', reusableEngins)

    // faire un GroupBy simu_engin (ne marche pas en BD)
    var groups = []
    var num =  1
    reusableEngins.forEach(r => {
      var key = 'simu_engin' + r.simu_engins_id
      if(!groups[key]) {
        groups[key] = {'simu_engins_reference':r.simu_engins_reference, 'code':r.code, 'nom':r.nom, 'simu_engins_id':r.simu_engins_id, 'selected':false}
        groups[key].usages = new Array()
        num++
      }
      
      console.log('AddEnginController::insertReusables, push in ', r, key, groups[key].usages)
      groups[key].usages.push(r)


    })
    console.log('AddEnginController::insertReusables, groupByEngin', groups)

    // transformert le tableau associatif en indexed
    var reusablesEnginsGroupBy = []
    for(var key in groups) {
      var g = groups[key]
      var item = {'simu_engins_id':g.simu_engins_id, 'code':g.code, 'nom':g.nom, 'simu_engins_reference': g.simu_engins_reference, 'usages':g.usages}
      reusablesEnginsGroupBy.push(item)
    }

    // Attention. Cloner le tableau avant de l'insérer dans la liste des phases / Sinon on aura que des références sur les mêmes engins
    this.recombinedPhasesOptions.forEach(PO => {
      var reusableInstance = JSON.parse(JSON.stringify(reusablesEnginsGroupBy)) // cloner pour chaque phase
      PO.reusableEngins = reusableInstance
    })

    /* ajouter une info pour les différencier (utile ?) */
    /*i=0
    this.recombinedPhasesOptions.forEach(PO => {
      var engins = PO.reusableEngins
      engins.forEach(r => {
        i++
        r.rang = i
      })
    })*/

  }

/*
* Réaction au click sur un engin réutilisable
* -> désélecter les autres références de même engin dans les autres phases
* -> disable du champ quantity
* Attention à la déselection, on ne enable pas systématiquement le champ quantity
*/
  doOnCheckReusable(reusable, phase) {
    console.log('AddEnginController::doOnCheckReusable', reusable, phase)
    var simu_engins_id = reusable.simu_engins_id
    var selected = reusable.selected

    if(selected) {
      this.unselectReusables(simu_engins_id)
      //phase.quantitydisabled = true
      reusable.selected = true // re-select l'engin cliqué
      }

      // gérer l'activation des champs quantity
      //this.checkQuantityDisable()
  }

/*
* Désélecte tous les choix vers un engin même engin
*/
  unselectReusables(simu_engins_id) {
    this.recombinedPhasesOptions.forEach(PO => {
      var engins = PO.reusableEngins
      engins.forEach(r => {
        if(r.simu_engins_id == simu_engins_id)
          r.selected = false
      })
    })
  }

/*
* Quantity disable si au moins un des reusable est checké
*/
  checkQuantityDisable() {
    this.recombinedPhasesOptions.forEach(PO => {
      if (this.phaseHasReusablesSelected(PO)) 
        PO.quantitydisabled = true
      else  
        PO.quantitydisabled = false
      })
  }

/*
* Teste s'il y  a des sélections d'engins réutilisables dans une phase
*/
  phaseHasReusablesSelected(phase) {
    if(phase.reusableEngins == undefined) // possible à l'init du formulaire
      return false
    var reusables = phase.reusableEngins

    var selections = reusables.filter(r => r.selected == true)
    return selections.length > 0
  }



/*
* renvoie l'engin sélectionné à partir de la liste des engins
*/
  getSelectedEngin(id) {

    var list = this.enginsList
    if(!list)
      return null

    var engin = this.enginsList.filter(e => e.id == id)
    return engin[0]

  }


/*
* Réorganise l'imbrication phases / options. Une phase contient un tableau d'options (ou pas), un engin et une quantité
*/
  recombinePhasesOptions(phases, options, godets, engin, famille) {
    var rePhases = [], reOptions = []
    var onePhase = {}, oneOption = {}

    // godets, seulement pour les pelles et propositions <> selon le type d'engin, quelle que soit la phase  
    var oneGodet = (famille.code == 'PELL') ? godets : undefined 
    if(oneGodet) {
      oneGodet = oneGodet.filter(g => g.const_engins_id == engin.id)    
      console.log('AddEnginController::recombinedPhasesOptions, setting godets', oneGodet)
      this.setDescriptionGodets(oneGodet)
    }

    phases.forEach(phase => {
        onePhase = {}
        oneOption = {}

        onePhase.nom = phase.const_phases.nom
        onePhase.id = phase.const_phases.id
        onePhase.code = phase.const_phases.code
        oneOption = options[onePhase.code]

        if(!oneOption ||(oneOption.length == 1 && (oneOption[0].code == "SANS" || oneOption[0].code == "GODE" )))
          oneOption = undefined
        onePhase.options = oneOption
        onePhase.selectedOptionId = 0

        engin.nomFamille = famille.nom
        onePhase.engin = engin
        onePhase.quantity = 0;
        onePhase.quantitydisabled = false;

        onePhase.selectedOptionId = 0 // par défaut
        if(oneOption != undefined)
          onePhase.selectedOptionId = parseInt(oneOption[0].id, 10) // sinon initialisé sur le première option

        if(!oneGodet || oneGodet.length == 0)
          oneGodet = undefined
        onePhase.godets = oneGodet  
        onePhase.selectedGodetId = 0
        if(oneGodet != undefined) {
          onePhase.selectedGodetId = parseInt(oneGodet[0].id, 10) // sinon initialisé sur le 1er godet          
        }

        rePhases.push(onePhase)

      })
    //console.log('AddEnginController::recombinePhasesOptions', rePhases)
    return rePhases

  }


/*
* Transformer le iste des paramétres en un format ecceptable par le compsant propertiesList
*/
  formatParamsForEngin(parametresList) {
    var formatted = [];
    console.log('formatParamsForEngin', parametresList)
    /*
    * @todo : regroupoer les paramètres par type (TECH, PRIX, ...) et trier par ordre - quand la table contiendra ces colonnes
    */
    parametresList.sort((a, b) => a.Ordre - b.Ordre)
    var paramsTech = parametresList.filter(p => p.Type == 'TECH')
    var paramsPrix = parametresList.filter(p => p.Type == 'PRIX')
    var allParams = []
    // concaténer et insérer des lignes comme séparateur de section
    allParams = allParams.concat([{'Parametre': '<span class="separator">Fiche technique</span>', 'Donnee': '', 'Unite' : ''}])
    allParams = allParams.concat(paramsTech)
    allParams = allParams.concat([{'Parametre': '<span class="separator">Coûts</span>', 'Donnee': '', 'Unite' : ''}])
    allParams = allParams.concat(paramsPrix)
//    allParams.splice(2, 0, {'Parametre': 'Energie de compactage', 'Donnee':'moyenne', 'Unite':''})
// BC 2017/12 c'est quoi cette ligne au dessus ???!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    allParams.forEach(p => {
      var label = p.Parametre;
      var value = p.Donnee + ' ' + p.Unite;
      formatted.push({'label':label, 'value':value})
    })
    this.formattedParams = formatted;
  }


  validate2(echelon) {

var currentEchelon
    var enginsToAdd = []

 //   this.echelon = currentEchelon = echelon
    currentEchelon = echelon

console.log('AddEnginController::validate in echelon', currentEchelon)

      // on a l'échelon, on peut parser le form, phase : phase
    var phasesSelections = this.recombinedPhasesOptions
    phasesSelections.forEach(phaseSelection => {
        var engins = this.createEnginsListFromSelectionPhase(currentEchelon, phaseSelection) // désérialiser le résultat avec "quantity"
        enginsToAdd = enginsToAdd.concat(engins) // push array in another
    })
    console.log('AddEnginController::validate, ready to add All for echelon ', enginsToAdd, currentEchelon)

    return this.addEngins(enginsToAdd, currentEchelon)

    .then(_ => {
        // this.defineConsigneEchelons()
        console.log('AddEnginController::validate, calling doRefreshEchelon for', currentEchelon)
        this.doRefreshEchelon(currentEchelon)
        this.reset()
        })

    }

  /*
  *   Enregistrement des engins dans l'échelon courant (ou un nouvel échelon à créer ici)
  */
  validate() {

    var promise
    if(!this.echelon)
      {
      console.log('AddEnginController::validate, calling doAddEchelon ')
      //promise = this.doAddEchelon() //  appel de  MouvementController::addEchelon
    //  return this.doAddEchelon() //  appel de  MouvementController::addEchelon
    return this.ApiSimu.createEchelon(this.parentMouvement.currentMouvement.simuMouvement)
      .then(newEchelon => {
          var echelon = new Object();
		  jQuery.extend(echelon, newEchelon);
          echelon.formattedEnginsList = [];
          this.validate2(echelon)
        })
      }
      else {
            this.validate2(this.echelon)
      }
  }

  addEnginsBC(engins, echelon) {
      var reference = 1
      this.addReferenceToEngins(engins, reference)
      var allPromises = []

      engins.forEach(engin => {
        var promise = this.ApiSimu.saveEngin(engin, echelon)
            allPromises.push(promise)
        })
      return Promise.all(allPromises)

    .then(allResults => {
      console.log('AddEnginController::addEngins, all added', allResults)
      return allResults
    })
  }

  addEngins(engins, echelon) {    

    // BC 12/2017 - il y a un bug dans getSimilarSimuEngins lors de la création du premier engin
      // du coup je bidouille et je duplique pour créer une autre fonction sans l'appel  à getSimilarSimuEngins s'il est inutile (premier engin ! ça tombe bien :)

    if ((typeof(echelon.formattedEnginsList) == 'undefined') || (echelon.formattedEnginsList.length < 1)) {
        return(this.addEnginsBC(engins, echelon))
    }

    else {

    return this.ApiSimu.getSimilarSimuEngins(engins[0].const_engins_id)
    .then( similars => {
      var reference = 0
      var last
      if(similars && similars.length){
        last = similars.pop()
        reference = last.reference +1
      }
      else
        reference = 1
      this.addReferenceToEngins(engins, reference)
    

    var allPromises = []
    engins.forEach(engin => {
        var promise = this.ApiSimu.saveEngin(engin, echelon)
        allPromises.push(promise)
      })

    return Promise.all(allPromises)
  })
    .then(allResults => {
      console.log('AddEnginController::addEngins, all added', allResults)
      return allResults
    })

    // 'vrai' chainage des Promises
    /*var p = Promise.resolve()
    allPromises.forEach(oneP => {
      p = p.then(oneP)
    })
   return p.then( _ => {console.log('AddEnginController::addEngins, alladded ', _)})*/
  }

  }

/*
* Numéroter les engins à partir d'une reference. Suels les nouveaux engins sont concernés (donc simu_engins_id est nul)
*/
  addReferenceToEngins(engins, startReference) {
    console.log('AddEnginController::addReferenceToEngins', startReference)

  var reference = startReference
    engins.forEach(e => {
      if(e.simu_engins_id == 0) {
          console.log('AddEnginController::addReferenceToEngins',e, reference)
        e.reference = reference
        reference++
      }

    })

  }

/*
* Crééer une liste d'engins-phase-options à destination d'un échelon
*/
  createEnginsListFromSelectionPhase(echelon, phaseSelection) {

    var selectionEnginsList = []
    var selectionEngins = {}
    var quantity

   /* if(this.phaseHasReusablesSelected(phaseSelection))
        quantity = 0
    else*/
      quantity = phaseSelection.quantity
    // pour cette phase, on construit la liste des engins
        selectionEngins =
           {'const_phases_id':  phaseSelection.id,
            'const_options_id':  phaseSelection.selectedOptionId,
            'const_godets_id':  phaseSelection.selectedGodetId,
            'simu_engins_id':   0, // pas encore défini
            'const_engins_id':  phaseSelection.engin.id, 
            'simu_echelons_id':  echelon.id
            }
        //console.log('AddEnginController::createEnginsListFromSelectionPhase, ready to add engins X ', phaseSelection.code, quantity, selectionEngins)
    
    for(var i=0; i<quantity; i++) {          
        var engin = Object.assign({}, selectionEngins)
        selectionEnginsList.push(engin);
        console.log('AddEnginController::createEnginsListFromSelectionPhase, quantity', quantity, selectionEnginsList)
      }

    // ajouter les "reusables"  
    selectionEnginsList = this.addReusablesEngins(phaseSelection, selectionEngins, selectionEnginsList)  
        
    return selectionEnginsList
 }

 /*
 * Pour une phase, ajouter à la liste d'engins, les engins réutilisables
 */
 addReusablesEngins(phase, enginType, selectionEnginsList)   {
  if(phase.reusableEngins == undefined) // pas de reusables selectés
      return selectionEnginsList

    var reusables = phase.reusableEngins

    var selectedReusables = reusables.filter(r => r.selected == true) // on ne retient que les 'selected' (check)
    console.log('AddEnginController::addReusablesEngins, selectedReusables', selectedReusables)

    selectedReusables.forEach(sel => {  // réutiliser l'engin type fourni et l'enrichir avec le simu_engins_id de l'engin existant
      // faire une copie de l'objet pour ne pas modifier sa référence
      var enginToAdd = Object.assign({}, enginType)
      enginToAdd.simu_engins_id = sel.simu_engins_id

      selectionEnginsList.push(enginToAdd) // l'ajouter à la liste
      console.log('AddEnginController::addReusablesEngins', enginToAdd)
    })

    return selectionEnginsList
  
 }

/* NOT USED !!
* Traitement d'une sélection en step4
* retourne tableau d'engins (i.e. simu-engin) au format de la DB (sans la propriété quantity)
*/
  /*multiplyEnginsFromSelection(phaseSelection) {

    console.log('AddEnginController::multiplyEnginsFromSelection', phaseSelection)

    var engins = []
    var N = phaseSelection.quantity
    delete phaseSelection.quantity

    for (let i = 0; i < N; i++) {
          engins.push(phaseSelection)
    return engins
  }
}*/

setDescriptionGodets(godets)
{
  this.descriptionGodets = []
  if(!godets)
    return

  godets.forEach(g => {
    var description = {}
    description.title = g.nom
    description.items = 
        [{label:"nombre de dents", value : g.dents},
            {label:"capacité", value : g.capacite + " m3"},
            {label:"utilisable sur sol rocheux", value : g.solrocheux ? "oui" : "non"}
        ]
  
  this.descriptionGodets.push(description)
    })
}



/*
* Il suffit qu'un des compteur soit <> 0 (les options s'il y en a, sont toujours initialisées )
*/
  isDataValid () {

    let hasEngin = Boolean(this.dataEngin.famille) && Boolean(this.dataEngin.engin)
    if(!hasEngin)
      return false
    if(!this.recombinedPhasesOptions)
      return false

    //console.log('AddEnginController::isDataValid, recombinedPhasesOptions', this.recombinedPhasesOptions)

    var hasPositive = false  
    for(var i=0; i< this.recombinedPhasesOptions.length; i++) {
      var PO = this.recombinedPhasesOptions[i]
      PO.quantity = Math.max(PO.quantity, 0)  // s'assurer qu'on a bien une valeur >=0 (on ne sort pas de la boucle pour forcer les >0 dans la vue)
      if(PO.quantity > 0)
          hasPositive = true
      if(this.phaseHasReusablesSelected(PO))  
        hasPositive = true

    }
    return hasPositive
  } 

/*
*
*/
  cancel() {
    this.reset()
    if (this.doCancel) this.doCancel()

    if(!this.echelon)  
      this.parentMouvement.setCurrentOnglet(this.parentMouvement.echelons.length)
  }

/*
*
*/

  reset(echelon, selectedEngin) {
    this.dataEngin = {}
    this.dataPhases = {}

    if(!echelon) { // Cas : Nouvel echelon
      this.newEchelon = new Echelon()
      return this.fetchFamillesEngins()
    } else {
      if(selectedEngin) { // Cas : Edition d'un engin
        this.newEchelon = echelon
        return this.fetchFamillesEngins()
        .then(_ => this.dataEngin.famille = selectedEngin.famille)
        .then(_ => this.fetchEngins())
        .then(_ => this.dataEngin.engin = selectedEngin.engin)
        .then(_ => this.fetchParametres())
        .then(_ => {
          this.dataPhases[selectedEngin.phase].option = selectedEngin.option
          this.dataPhases[selectedEngin.phase].quantity = 1
        })
      } else { // Cas : Ajout d'un engin
        this.newEchelon = echelon
        return this.fetchFamillesEngins()
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/add-engin/add-engin.controller.js